import { useMemo, type PropsWithChildren } from 'react';

import { FlagProvider, type IConfig } from '@unleash/proxy-client-react';

import { baseConfig } from '@moniebook-web/utils';

import { PLATFORM_TYPE } from '@register-ui/utils';

import { FlagContextData } from './flag-context-data';
import { LoadAllFeatureFlags } from './load-all-feature-flags';

export function FlagProviderWrapper({ children }: Readonly<PropsWithChildren>) {
    const bootstrap = useMemo(() => {
        try {
            const cachedRepo = localStorage.getItem('unleash:repository:repo');
            return cachedRepo ? JSON.parse(cachedRepo) : [];
        } catch {
            return [];
        }
    }, []);

    const config: IConfig = {
        ...baseConfig.UNLEASH,
        bootstrap,
        bootstrapOverride: false,
        refreshInterval: 30,
        context: {
            properties: { platformType: PLATFORM_TYPE.WEB },
        },
    };

    return (
        <FlagProvider config={config}>
            <FlagContextData />
            <LoadAllFeatureFlags />
            {children}
        </FlagProvider>
    );
}
